export enum SocietyValidationAccountOrigin {
    Login = 'login',
    Navigation = 'navigation',
    SocietyDataUpdate = 'society-data-update',
    RecipientUpdate = 'recipient-update'
}

export interface SocietyValidationAccount {

    isValid: boolean;

    redirectUrl: string;
}

export interface SocietyValidationAccountDialogData {

    origin: SocietyValidationAccountOrigin;

    redirectUrl: string;

    returnUrl: string;
}
